export function getDadosReceber (obito) {
  obito.pessoa = obito.registro.pessoa
  obito.registro = objetoRegistroReceber(obito)

  return obito
}

function objetoRegistroReceber (obito) {
  obito.registro.partes = obito.registro.partes

  return obito.registro
}
